"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$aligns: (\n  center: center,\n  end: flex-end,\n  start: flex-start,\n  stretch: stretch,\n);\n\n$justifies: (\n  around: space-around,\n  between: space-between,\n  center: center,\n  end: end,\n  even: space-evenly,\n  start: start,\n);";
var FlexCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.FlexCustomize = FlexCustomize;
